import { styled } from 'goober';
import { forwardRef } from 'react';

export const ModalContentStyled = styled('div', forwardRef)<{ padding?: number }>`
    padding: 0px ${(props) => props.padding ?? 20}px;
    display: flex;
    flex-direction: column;
    overflow: auto;
`;
